module.exports = __webpack_public_path__ + "media/images/logo/Logo Artha Budaya_Ungu Non Tagline-53f3dcf6b3672d148f0537c7f3d72b05.png";